import { useContext, useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import CampaignFormStepButtons from 'pages/campaigns/campaignForm/components/campaignFormContainer/components/campaignFormStepButtons/campaignFormStepButtons';
import PhotoGuidelineFieldGroup from './components/photoGuidelineFieldGroup/photoGuidelineFieldGroup';
import TagGuidelineFieldGroup from './components/tagGuidelineFieldGroup/tagGuidelineFieldGroup';
import TextGuidelineFieldGroup from './components/textGuidelineFieldGroup/textGuidelineFieldGroup';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import { FashionCampaignFormStepTwoContext } from '../../fashionCampaignFormStepTwo.context';

const PhotoForm = () => {
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);
  const { isFormValid, onClickNextButton } = useContext(
    FashionCampaignFormStepTwoContext,
  );

  const [photoModelFull, photoModelHalf, photoModelCloseup] = useWatch({
    control: guidelineRuleFormMethods?.control,
    name: [
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_FULL,
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_HALF,
      GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.PHOTO_MODEL_CLOSEUP,
    ],
  });

  const isValidNextButton = useMemo(() => {
    if (
      !isFormValid ||
      // 필수 사진이 없을 경우
      (photoModelFull?.length <= 0 &&
        photoModelHalf?.length <= 0 &&
        photoModelCloseup?.length <= 0)
    ) {
      return false;
    } else {
      return true;
    }
  }, [isFormValid, photoModelFull, photoModelHalf, photoModelCloseup]);

  return (
    <>
      {/* 사진 가이드라인 */}
      <PhotoGuidelineFieldGroup />

      {/* 문구 가이드라인 */}
      <TextGuidelineFieldGroup />

      {/* 태그 가이드라인 */}
      <TagGuidelineFieldGroup />

      <CampaignFormStepButtons
        disabledNextButton={!isValidNextButton}
        onClickNext={onClickNextButton}
      />
    </>
  );
};

export default PhotoForm;
